import { render, staticRenderFns } from "./moveForm.vue?vue&type=template&id=431f6f07&scoped=true&"
import script from "./moveForm.vue?vue&type=script&lang=js&"
export * from "./moveForm.vue?vue&type=script&lang=js&"
import style0 from "./moveForm.vue?vue&type=style&index=0&id=431f6f07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f6f07",
  null
  
)

export default component.exports